import { useQuery, useSubscription } from "@apollo/client";
import {
  MY_LEAVE_GET_EMAILS_BY_COMPANY,
  MY_LEAVE_SUBSCRIPTION_EMAILS_BY_COMPANY,
} from "my-leave/graphql";

export const useMyLeaveEmailsByCompany = () => {
  const { data, loading, error } = useQuery(MY_LEAVE_GET_EMAILS_BY_COMPANY, {
    fetchPolicy: "cache-and-network",
  });

  const result = data?.getEmailsByCompanyList || [];

  useSubscription(MY_LEAVE_SUBSCRIPTION_EMAILS_BY_COMPANY, {
    fetchPolicy: "network-only",
  });

  return {
    data: result,
    loading,
    error,
  };
};

export default useMyLeaveEmailsByCompany;
